import React, { useState, useMemo } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styled from "styled-components";

import useStatesByCountry from "hooks/useStatesByCountry";
import useFeePreferencesByState from "hooks/useFeePreferencesByState";
import useFeeDescriptionsByState from "hooks/useFeeDescriptionsByState";
import SoleraLoader from "components/UI/Loader/SoleraLoader";
import UISearchDropdown from "components/UI/SearchDropdown";
import FeePreferencesWidget from "./Widget";
import commonStyles from "css/common.module.css";
import { selectLocationStateDetails } from "selector/initializeSelector";

const Container = styled.div.attrs({ className: "preferences" })`
  & .heading {
    background: ${props => props.theme.colors.white};
    margin: 0 0 24px;
    padding: 24px;
  }

  & .dropdown {
    display: inline-block;
  }
  .search-dropdown__input-wrapper {
    margin-bottom: 10px;
  }

  & .widgets {
    margin: 0 auto;
    max-width: 1500px;
  }
`;

const mapStateToDropdownItem = ({ code, name }) => ({
  value: code,
  text: name
});

const FeePreferences = ({ onError, stateDetails }) => {
  const [currentState, setCurrentState] = useState(null);
  const [states, statesLoading] = useStatesByCountry("US", onError);
  const [preferencesObj, preferencesLoading] = useFeePreferencesByState(
    currentState,
    onError
  );
  const [descriptions, references, descriptionsLoading] = useFeeDescriptionsByState(
    currentState,
    onError
  );
  const payType = useMemo(() => {
    const payTypeObj = stateDetails.find(
      x => x.state === currentState && /^pay type/i.test(x.description)
    );
    return (
      payTypeObj &&
      payTypeObj.description &&
      payTypeObj.description.split(":")[1].trim()
    );
  }, [currentState, stateDetails]);

  const stateItems = states === null ? [] : states.map(mapStateToDropdownItem);
  const placeholder = states === null ? "Loading..." : "";

  const handleStateSelection = ({ value }) => setCurrentState(value);

  return (
    <Container className={`${commonStyles.page}`}>
      <SoleraLoader
        open={statesLoading || preferencesLoading || descriptionsLoading}
      />

      <div className="heading">
        <h5 className="h5">Fees Preferences</h5>

        <p>Please select a State from the dropdown to start your search.</p>

        <div className="dropdown">
          <UISearchDropdown
            label="State:"
            placeholder={placeholder}
            items={stateItems}
            onSelection={handleStateSelection}
          />
          * Read Only
        </div>
      </div>

      <div className="widgets">
        {preferencesObj &&
          Object.entries(preferencesObj).map(([type, { preferences }]) => (
            <FeePreferencesWidget
              key={type}
              type={type}
              payType={payType}
              // startDate={startDate.toLocaleDateString("en-US")}
              // endDate={endDate.toLocaleDateString("en-US")}
              preferences={preferences}
              feeDescriptions={descriptions}
              feeReferences={references}
            />
          ))}
      </div>
    </Container>
  );
};

FeePreferences.propTypes = {
  onError: PropTypes.func
};

export default connect(state => ({
  stateDetails: selectLocationStateDetails(state)
}))(FeePreferences);
